import { SELECIONAR_PARAMETROS_BUSCA_REPASSE } from '../types';

export default function selecionaParametrosBuscaRepasse (data) {
  return {
    type: SELECIONAR_PARAMETROS_BUSCA_REPASSE,
    payload: data
  }
}
